import {LoadingState} from "@/utils/loadingUtils"

const LoadingMixin = {
  data() {
    return {
      state: LoadingState.loading,
      i18nErrorType: 'unknown',
      errorUuid: "",
      errorLinkUrl: ""
    }
  },
  methods: {
    handleError(_err: any) {
      (this as any).state = LoadingState.error;
    },
    getI18nErrorString() {
      return 'common.error.' + (this as any).i18nErrorType
    },
    getI18nErrorStringByKey(key: string) {
      return 'common.error.' + key
    },
    handleErrorWithI18nString(err: any) {

      if (err && err.response && err.response.data) {
        if(typeof err.response.data.error === 'string') {
          if (Array.isArray(err.response.data.details) && err.response.data.details.length > 0) {
            // I think we don't have details in OnB-CC-App errors.
            (this as any).i18nErrorType = err.response.data.error + '_' + err.response.data.details[0]
          } else {
            (this as any).i18nErrorType = err.response.data.error
          }
        }
        if(err.response.data.uuid) {
          (this as any).errorUuid = err.response.data.uuid
        }

      }
      (this as any).state = LoadingState.error;
    },
    handleSuccess() {
      (this as any).state = LoadingState.success;
    },
    clearErrorOfLoadingContainer(): void {
      (this as any).state = LoadingState.success
    }
  }
}

export default LoadingMixin
